import type {
  CommonProductFragment,
  ParentProductFragment,
  ProductDetailFragment,
  CommonProductDetailFragment
} from '~/lib/Shop/generated/schema';

export type ConfigurableProduct = ProductDetailFragment & ParentProductFragment;

export function isConfigurableProduct(
  product?:
    | { __typename: string }
    | CommonProductFragment
    | CommonProductDetailFragment
    | null
): product is ConfigurableProduct {
  return product?.__typename === 'ConfigurableProduct';
}
